<template>
  <vh-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="fit-content"
    modal
    custom-class="VmpGDCardDialog"
    append-to-body
    :title="title"
    @open="open"
    @opened="opened"
  >
    <div class="mainContent" v-loading="loading">
      <iframe
        :src="url"
        frameborder="0"
        :style="{ height: size.height, width: size.width }"
      ></iframe>
    </div>
  </vh-dialog>
</template>
<script>
  import { usePendantServer } from 'middle-domain';

  export default {
    name: 'VmpPendantCard', // 推屏挂件
    data() {
      return {
        dialogVisible: false,
        loading: true,
        url: '',
        title: '挂件',
        size: { width: '768px', height: '300px' }
      };
    },
    beforeCreate() {
      this.pendantServer = new usePendantServer();
    },
    async created() {
      this.init();
      this.initEvents();
    },
    methods: {
      /**
       * 对话框打开事事件
       */
      openDialog(data) {
        this.loading = true;
        this.dialogVisible = true;
        this.title = data.name;
        this.url =
          data.url +
          '?webinarId=' +
          this.$domainStore.state.roomBaseServer.watchInitData?.webinar?.id;
        const extend = data.extend ? JSON.parse(data.extend) : {};
        this.size.width = extend.width ? extend.width : '768px';
        this.size.height = extend.height ? extend.height : '300px';
      },
      initEvents() {
        this.$emitter.on(this.$EMIT_DEFINE.gd_card_open, data => {
          this.openDialog(data);
        });
      },
      init() {
        let webinarId = this.$domainStore.state.roomBaseServer.watchInitData?.webinar?.id;
        this.pendantServer
          .getPendantInfo({
            webinar_id: webinarId
          })
          .then(res => {
            if (res.data) {
              this.$emit('getPendantInfo', res.data);
            }
          });
      },
      open() {},
      opened() {
        this.loading = false;
      },
      handleClose() {
        this.dialogVisible = false;
      }
    }
  };
</script>
<style lang="less">
  .VmpGDCardDialog {
    .vh-dialog__body,
    .mainContent {
      iframe {
        width: 100%;
        // min-height: 300px;
      }
    }
  }
</style>
